exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media print {\n.form-section[data-v-939f626c] {\n        page-break-before: always;\n}\n.break-protect[data-v-939f626c] {\n        page-break-inside: avoid;\n}\n}\n", ""]);

// exports
